export const CONSTANTS = {
  PAGES: {
    HOME: `/`,
    ABOUT_US: `/about-us`,
    LOGIN: `/login`,
    DELETE_ACCOUNT: `/delete-account`,
    BLOG: `/blog`,
    CONTACT: `/contact`,
    PRIVACY_POLICY: `/privacy-policy`,
    LEGAL_ADVISE: `/legal-advise`,
    ACCOUNT_CONFIG_SUCCESS: `/account-config-success`,
    VERIFY_USER: `/verify-email`,
    REGISTER: `/register`,
    PRODUCT: `/product`,
    MY_PRODUCTS: `/my-products`,
    MY_RENTS: `/my-rents`,
    CREATE_PRODUCT: `/create-product`,
  }
};

export const PRIMARY_COLOR = "#5FFFA0";
export const SECONDARY_COLOR = "#3EDB7D";
export const TERTIARY_COLOR = "#4A4A4A";
export const INPUT_BACKGROUND_COLOR = "#ADB2AB";